import phone_icon from "../Assets/SVG/phone_icon.svg";
import localisation_icon from "../Assets/SVG/localisation_icon.svg";
import mail_icon from "../Assets/SVG/mail_icon.svg";
import linkedin_icon from "../Assets/SVG/linkedin_icon.svg";
import instagram_icon from "../Assets/SVG/instagram_icon.svg";
import facebook_icon from "../Assets/SVG/facebook_icon.svg";
import youtube_icon from "../Assets/SVG/youtube_icon.svg";
import { IoIosArrowRoundUp } from "react-icons/io";
import { FaArrowRight } from "react-icons/fa6";

import axios from "axios";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import SuccesPopup from './SuccesPupup';
import { BiSolidMessageError } from "react-icons/bi";
import {BsSendCheckFill} from 'react-icons/bs'
import { sendContactData } from '../api/axios';
const Footer = () => {
  const { t , i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const [message, setMessage] = useState({
    name: "",
    email: "",
    phone_number: "",
    message: ""
})
const handleInput = (e) => {
    setMessage({ ...message, [e.target.id]: e.target.value })
    console.log(message);
};
  
// Success popup state
const [done , setDone] = useState(false)
const [err , setErr] = useState(false)
const closeDone = () => { setDone(!done) }
const closeError = () => { setErr(!err) }

const handleSubmit = async (e) => {
e.preventDefault();
try {
  const response = await sendContactData(message);
  setMessage({
    name: "",
    email: "",
    phone_number: "",
    message: ""
  });
  setDone(true);
  console.log('Message sent successfully:', response);
} catch (error) {
  setErr(true);
  console.error('Error sending message:', error);
}
}
  return (
    <footer className="w-full h-max overflow-hidden flex flex-col bg-[#282828]">
      <div className="flex bg-white justify-end items-center w-full h-[20vh] md:h-[15vh] px-[5%]">
        <span
          className="text-4xl text-white bg-primary rounded-full p-3 cursor-pointer animate-bounce"
          onClick={scrollToTop}
        >
          <IoIosArrowRoundUp />
        </span>
      </div>
      <div className="w-full h-30 md:h-[20vh] bg-[#282828]  md:flex justify-between">
        <span className="w-[5vw] bg-white rounded-br-3xl"></span>
        <span
          className="w-full md:w-[90vw] bg-white"
        >
          <span className="w-full h-full p-8 md:px-[7vw] bg-primary02 rounded-t-3xl overflow-hidden flex items-center">
            <div className="w-full h-max flex justify-center items-center relative after:absolute after:content-[''] after:w-full after:h-[1px] after:bg-[#3D414C] after:left-1/2 after:-translate-x-1/2  after:-bottom-8">
              <h1 className="my-0 font-bold text-white text-2xl sm:text-3xl md:text-5xl tracking-wide">
                  {t("contactpage.titlefootercontact")}
                <span className="text-primary font-bold">{t("contactpage.titlefootercontact2")}</span>
              </h1>
            </div>
          </span>
        </span>


        <span className="w-[5vw] bg-white rounded-bl-3xl text-black"></span>
      </div>

      <div
        className={`w-full h-max flex flex-col-reverse md:flex-row justify-center items-center px-6 md:px-20 xxl:px-24 py-10 md:py-3 xl:py-10 ${isRTL ? 'rtl' : 'ltr'}`}>
        <section className="flex w-full flex-col gap-10 justify-center items-center md:items-start md:justify-start md:w-[60%] text-white  ">
          <h1 className={`my-0 z-[1] relative after:absolute after:content-[''] after:w-full md:after:w-1/2 after:h-[2px] md:after:h-1 after:bg-secondary ${isRTL ? 'after:right-0' : 'after:left-0'}  after:-bottom-2 md:after:-bottom-4 after:-z-[1] text-[20px] md:text-[25px] lg:text-[40px]`}>
            {t("contactpage.title")}
          </h1>

          <form
            className="w-full md:max-w-[80%] "
          >
            <div className="grid md:grid-cols-2 md:gap-6">
              <div className="relative z-0 w-full mb-5 group">
                <input 
                  value={message.name}
                  onChange={handleInput}
                  type="text"
                  name="name"
                  id="name"
                  className="block py-2.5 px-0 w-full text-sm text-inputcolor bg-transparent border-0 border-b-2 border-inputcolor appearance-none focus:border-secondary focus:outline-none focus:ring-0 peer"
                  placeholder={t("contactpage.form.name")}
                  required
                />
                <label
                  htmlFor="name"
                  className="peer-focus:font-medium absolute text-sm text-inputcolor duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-secondary peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                >
                </label>
              </div>
              <div className="relative z-0 w-full mb-5 group">
                <input 
                  value={message.phone_number}
                  onChange={handleInput}
                  type="text"
                  name="phone"
                  id="phone_number"
                  className="block py-2.5 px-0 w-full text-sm text-inputcolor bg-transparent border-0 border-b-2 border-inputcolor appearance-none focus:border-secondary focus:outline-none focus:ring-0 peer"
                  placeholder={t("contactpage.form.phone")}
                  required
                />
                <label
                  htmlFor="phone"
                  className="peer-focus:font-medium absolute text-sm text-inputcolor duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-secondary peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                >
                </label>
              </div>
            </div>
            <div className="relative z-0 w-full mb-5 group">
              <input 
                value={message.email}
                onChange={handleInput}
                type="email"
                name="email"
                id="email"
                className="block py-2.5 px-0 w-full text-sm text-inputcolor bg-transparent border-0 border-b-2 border-inputcolor appearance-none focus:border-secondary focus:outline-none focus:ring-0 peer"
                placeholder={t("contactpage.form.email")}
                required
              />
              <label
                htmlFor="email"
                className="peer-focus:font-medium absolute text-sm text-inputcolor duration-300 transhtmlForm -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-secondary peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
              >
              </label>
            </div>
            <div className="relative z-0 w-full mb-5 group">
              <input 
                value={message.message}
                onChange={handleInput}
                type="text"
                name="message"
                id="message"
                className="block py-2.5 px-0 w-full text-sm text-inputcolor bg-transparent border-0 border-b-2 border-inputcolor appearance-none focus:border-secondary focus:outline-none focus:ring-0 peer"
                placeholder={t("contactpage.form.message")}
                required
              />
              <label
                htmlFor="message"
                className="peer-focus:font-medium absolute text-sm text-inputcolor duration-300 transhtmlForm -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-secondary peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
              >
              </label>
            </div>

            <button
              onClick={handleSubmit}
              className="text-white bg-secondary  flex justify-center items-center gap-2 text-lg rounded-full px-4 py-2 mt-10 "
            >
              {t("contactpage.form.button")}
              <FaArrowRight className={`${isRTL && 'rotate-180'}`}/>
            </button>
          </form>
        </section>

        <span className="flex flex-col justify-center gap-6 items-start w-[85vw] md:w-max ">
          <div className="bg-white w-full  md:w-max h-max gap-3 overflow-hidden rounded-md p-8 md:p-10  flex flex-col justify-between">
            <a
              href={`tel:+21267783603`}
              className="flex  w-max gap-3 items-center"
            >
              <img
                loading="lazy"
                className={`p-3 md:p-4 w-12 h-12 md:w-14 md:h-14 bg-[#F1F1F1] rounded-lg ${isRTL && 'rotate-180'}`}
                src={phone_icon}
                alt=""
              />
              <div className="flex flex-col items-start text-center md:text-start">
                <h6 className="w-max text-base font-semibold text-primary pb-[.5px]">
                  {t("contactpage.contactcards.card1")}
                </h6>
                <p className="text-xs text-[#4E4E4E]">
                  <a href={`tel:+21267783603`}>
                  {t("contactpage.contactcards.phone1")}
                  </a>
                </p>
              </div>
            </a>
            <a
              href={`mailto:${t("contactpage.contactcards.email1")}`}
              className="flex  md:w-max gap-3 items-center"
            >
              <img
                loading="lazy"
                className="p-3 md:p-4 w-12 h-12 md:w-14 md:h-14 bg-[#F1F1F1] rounded-lg"
                src={mail_icon}
                alt=""
              />
              <div className="flex flex-col">
                <h6 className="w-max text-base font-semibold text-primary pb-[.5px]">
                {t("contactpage.contactcards.card2")}
                </h6>
                <p className="text-xs text-[#4E4E4E]">
                  <a href={`mailto:${t("contactpage.contactcards.email1")}`} target="_blank" rel="noopener noreferrer">{t("contactpage.contactcards.email1")}</a>
                </p>
              </div>
            </a>
            <a
              href="https://maps.app.goo.gl/LAeAyPii9y4em8Yt7"
              target="_blank"
              rel="noopener noreferrer"
              className="flex  w-max md:w-[20rem] gap-3  items-center"
            >
              <img
                loading="lazy"
                className="p-3 md:p-4 w-12 h-12 md:w-16 md:h-14 bg-[#F1F1F1] rounded-lg"
                src={localisation_icon}
                alt=""
              />
              <div className="flex flex-col">
                <h6 className="w-max text-base font-semibold text-primary pb-[.5px]">
                {t("contactpage.contactcards.card3")}
                </h6>
                <span className="text-xs text-[#4E4E4E] w-[60%] md:w-auto">
                {t("contactpage.contactcards.adress")}
                </span>
              </div>
            </a>
          </div>
          <div
            className="w-full md:w-max md:ml-6 h-max overflow-hidden flex gap-2 justify-between md:justify-end mb-6 md:mb-0"
          >
            <span className={`w-1/2 md:w-max hidden md:flex gap-2 items-center justify-center text-lg text-white md:mr-2`}>
            {t("contactpage.contactcards.socialmedia")}
             <FaArrowRight className={`${isRTL && 'rotate-180 '}`}/>
            </span>
            <span
              className="w-full md:w-max flex justify-center md:justify-between gap-3 md:gap-0:">
              <Link
                href={""}
                // target="-blank"
                className="cursor-pointer">
                <img
                  loading="lazy"
                  className="p-2 flex self-center bg-primary h-10 w-10 rounded-lg"
                  src={linkedin_icon}
                  alt=""
                />
              </Link>
              <Link
                href={""
                }
                // target="-blank"
                className="cursor-pointer"
              >
                <img
                  loading="lazy"
                  className="p-2 flex self-center bg-primary h-10 w-10 rounded-lg"
                  src={instagram_icon}
                  alt=""
                />
              </Link>
              <Link
                href={""}
                // target="-blank"
                className="cursor-pointer"
              >
                <img
                  loading="lazy"
                  className="p-2 flex self-center bg-primary h-10 w-10 rounded-lg"
                  src={facebook_icon}
                  alt=""
                />
              </Link>
              <Link
                href={""}
                // target="-blank"
                className="cursor-pointer"
              >
                <img
                  loading="lazy"
                  className="p-2 flex self-center bg-primary h-10 w-10 rounded-lg"
                  src={youtube_icon}
                  alt=""
                />
              </Link>
            </span>
          </div>
        </span>
      </div>
      <div className={`w-full h-12 xxl:h-20 flex gap-2 justify-center items-center border-t border-inputcolor/50 ${isRTL ? 'rtl' : 'ltr'}`}>
          <p className='font-medium text-[10px]  md:text-[14px] xxl:text-[16px] xxxxl:text-[22px] text-white'>{t('footer.title')} <a href='https://softcactus.ma' target='_blank' rel="noreferrer" className='text-primary font-bold'> SOFT CACTUS </a> </p>
          <p className='font-medium text-[10px]  md:text-[14px] xxl:text-[16px] xxxxl:text-[22px] text-white'> {t('footer.year')}</p>
      </div>
      {done && <SuccesPopup close={closeDone} icon={<BsSendCheckFill size={40} fill='#0f9b0f'/>} don={t('popup.succes')}/>}
      {err && <SuccesPopup close={closeError} icon={<BiSolidMessageError size={40} fill='#f00'/>} don={t('popup.error')} erorr/>}
    </footer>
  );
};

export default Footer;
